module.exports = __webpack_public_path__ + "img/youhui_pc.6695b67b.png";